// MF-67 — Numeric input for Journal forms. Drop-in for <TextField type='number'>: same props and
// onChange(e) contract, but it only lets numbers through (typing/pasting text is ignored), hides the
// browser's tiny spinner and, with `stepper`, adds comfortable − / + buttons that respect min/max.
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const NumberField = ({
  value,
  onChange,
  allowNegative = true,
  allowDecimal = false,
  min,
  max,
  step = 1,
  stepper = false,
  InputProps,
  inputProps,
  ...props
}) => {
  const pattern = new RegExp(`^${allowNegative ? '-?' : ''}\\d*${allowDecimal ? '(\\.\\d*)?' : ''}$`)
  const emit = (v) => onChange?.({ target: { value: v } })
  const clamp = (n) => Math.min(max ?? Infinity, Math.max(min ?? -Infinity, n))
  const bump = (dir) => {
    const n = Number(value)
    const next = clamp((Number.isFinite(n) ? n : 0) + dir * step)
    emit(String(allowDecimal ? Number(next.toFixed(6)) : Math.round(next)))
  }
  const num = Number(value)
  const btn = { width: 28, height: 28, padding: 0 }

  return (
    <TextField
      {...props}
      type='text'
      value={value ?? ''}
      onChange={(e) => {
        if (pattern.test(e.target.value)) onChange?.(e)
      }}
      onBlur={(e) => {
        // Normalise leftovers like '-' or '3.' and clamp to the allowed range.
        if (value === '' || value === null || value === undefined) return props.onBlur?.(e)
        const n = Number(value)
        if (!Number.isFinite(n)) emit('')
        else if (clamp(n) !== n || String(n) !== String(value)) emit(String(clamp(n)))
        props.onBlur?.(e)
      }}
      inputProps={{ inputMode: allowDecimal ? 'decimal' : 'numeric', ...inputProps }}
      InputProps={{
        ...(stepper
          ? {
              startAdornment: (
                <InputAdornment position='start'>
                  <IconButton
                    aria-label='Decrease'
                    size='small'
                    style={btn}
                    disabled={props.disabled || (min !== undefined && num <= min)}
                    onClick={() => bump(-1)}
                  >
                    <FontAwesomeIcon icon={['fas', 'minus']} style={{ fontSize: 12 }} />
                  </IconButton>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='Increase'
                    size='small'
                    style={btn}
                    disabled={props.disabled || (max !== undefined && num >= max)}
                    onClick={() => bump(1)}
                  >
                    <FontAwesomeIcon icon={['fas', 'plus']} style={{ fontSize: 12 }} />
                  </IconButton>
                </InputAdornment>
              ),
              sx: { '& input': { textAlign: 'center' } }
            }
          : {}),
        ...InputProps
      }}
    />
  )
}

export default NumberField
